import { createDrawerLoader } from "@amzn/awsui-app-layout-loader";
import { createWidgetizedDrawer, DrawerImplementation } from "./implementation";

export const InternalDrawer = createWidgetizedDrawer(createDrawerLoader({ Fallback: DrawerImplementation }));
